const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common-ch/api-factory');
const serviceFactory = require('../resources/assets-common-ch/service-factory');
const routeAdderFactory = require('../resources/assets-common-ch/route-adder-factory');



function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/portfoliooverview/${apiConfig.apiversion}/`,
    transBaseUrl: `${config.baseUrl}/reports/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    positionsUrl: 'groupasset-positions',
    transactionsUrl: 'view-transaction',
    valueMovementUrl: 'groupasset-positions',
  });

  const service = serviceFactory({
    api,
  });

  return routeAdderFactory({ assetType: 'genericAssets', service });
}

module.exports = addRoutes;
